import { render } from "./CashDeposit.vue?vue&type=template&id=b6a23d42"
import script from "./CashDeposit.vue?vue&type=script&lang=js"
export * from "./CashDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__